/**
 * @flow
 * @relayHash 32ff29d778af599c1ec9e19ca20e16df
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Epg_viewer$ref = any;
export type queries_EpgQueryVariables = {|
  currentDate?: ?string
|};
export type queries_EpgQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: Epg_viewer$ref
  |}
|};
export type queries_EpgQuery = {|
  variables: queries_EpgQueryVariables,
  response: queries_EpgQueryResponse,
|};
*/


/*
query queries_EpgQuery(
  $currentDate: String
) {
  viewer {
    ...Epg_viewer_3qp2FF
    id
  }
}

fragment Epg_viewer_3qp2FF on Viewer {
  episodes(first: -1, day: $currentDate, showAll: true) {
    edges {
      node {
        id
        startDate
        endDate
        title
        state
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "currentDate",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_EpgQuery",
  "id": null,
  "text": "query queries_EpgQuery(\n  $currentDate: String\n) {\n  viewer {\n    ...Epg_viewer_3qp2FF\n    id\n  }\n}\n\nfragment Epg_viewer_3qp2FF on Viewer {\n  episodes(first: -1, day: $currentDate, showAll: true) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        title\n        state\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_EpgQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Epg_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "day",
                "variableName": "currentDate",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_EpgQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "episodes",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "day",
                "variableName": "currentDate",
                "type": "String"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": -1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "showAll",
                "value": true,
                "type": "Boolean"
              }
            ],
            "concreteType": "TVShowEpisodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TVShowEpisodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TVShowEpisode",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "startDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "state",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e885694c51c68267106e072766b57d90';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_EpgQuery.graphql.js